<div class="sz-time-wheel">
  <div class="sz-time-wheel__band" aria-hidden="true"></div>

  <div #hoursCol class="sz-time-wheel__col" (scroll)="onHoursScroll()" role="listbox" aria-label="Hours">
    @for (h of hours; track h) {
      <div class="sz-time-wheel__item">{{ h.toString().padStart(2, '0') }}</div>
    }
  </div>

  <div class="sz-time-wheel__sep" aria-hidden="true">:</div>

  <div #minutesCol class="sz-time-wheel__col" (scroll)="onMinutesScroll()" role="listbox" aria-label="Minutes">
    @for (m of minutes(); track m) {
      <div class="sz-time-wheel__item">{{ m.toString().padStart(2, '0') }}</div>
    }
  </div>
</div>
